import { render, staticRenderFns } from "./name.vue?vue&type=template&id=3e52a4b6&"
import script from "./name.vue?vue&type=script&lang=ts&"
export * from "./name.vue?vue&type=script&lang=ts&"
import style0 from "./name.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports